export default __webpack_public_path__ + "static/media/user_icon.56e1c91f.svg";